import { Component, Input } from '@angular/core';
import { TrendTileVm } from '../../../../domain/model/trend-metrics.model';

/** One trend tile: title, the neutral headline, and the change line coloured by its verdict. */
@Component({
  selector: 'ifbp-trend-tile',
  templateUrl: './trend-tile.component.html',
  styleUrls: ['./trend-tile.component.scss'],
  standalone: false,
})
export class TrendTileComponent {
  @Input() vm: TrendTileVm;
}
